import {
    getPaypalOrderId,
    showCartErrorHtml
} from '../api';
import {
    getPaypalButtonStyle
} from '../helper';

var loaderInstance = require('../loader');
var $loaderContainer = document.querySelector('.paypalLoader');
var loader = loaderInstance($loaderContainer);

/**
 * Creates order and returns an order id
 * @returns {string} an order id
 */
function createOrder() {
    return getPaypalOrderId();
}

/**
 * Makes post call to returnFromCart endpoint, goes to checkout place order stage
 */
function onApprove() {
    loader.show();

    $.ajax({
        type: 'POST',
        url: window.paypalUrls.returnFromCart,
        contentType: false,
        data: JSON.stringify({}),
        processData: false,
        success: () => {
            loader.hide();
            window.location.href = window.paypalUrls.placeOrderStage;
        },
        error: function () {
            loader.hide();
            if (window.location.href !== window.paypalUrls.cartPage) {
                window.location.href = window.paypalUrls.cartPage;
            }
            if (!document.querySelector('.cartError')) {
                showCartErrorHtml('An internal server error has occurred. \r\nRetry the request later.');
            }
        }
    });
}

/**
 * Hides loader on paypal widget closing without errors
 */
function onCancel() {
    loader.hide();
}

/**
 * Shows errors if paypal widget was closed with errors
 */
function onError() {
    loader.hide();
    if (window.location.href !== window.paypalUrls.cartPage) {
        window.location.href = window.paypalUrls.cartPage;
    }
    if (!document.querySelector('.cartError')) {
        showCartErrorHtml('An internal server error has occurred. \r\nRetry the request later.');
    }
}

/**
 *Inits paypal button on cart page
 */
function initPaypalButton() {
    loader.show();
    window.paypal.Buttons({
        createOrder,
        onApprove,
        onCancel,
        onError,
        style: getPaypalButtonStyle(document.querySelector('.js_paypal_button_on_cart_page'))
    }).render('.paypal-cart-button')
        .then(() => {
            loader.hide();
        });
}

export default initPaypalButton;
